/**
 * Build a plain-text convocation message ready to share via WhatsApp / Email / Copy.
 */
export function buildConvocationMessage(convocation, players, team, fields = []) {
  const c = convocation;
  const field = c.field_id ? fields.find((f) => f.id === c.field_id) : null;
  const lines = [];
  lines.push(`📋 *Convocazione ${team.name}*`);
  if (team.category) lines.push(`_${team.category}_`);
  lines.push("");
  lines.push(`*${c.title}*`);
  if (c.opponent) lines.push(`⚽ Avversario: ${c.opponent}`);
  if (c.match_date) {
    const d = new Date(c.match_date + "T00:00:00");
    const formatted = d.toLocaleDateString("it-IT", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    lines.push(`📅 Data: ${formatted}`);
  }
  if (c.meeting_time) {
    const place = c.meeting_place ? ` presso ${c.meeting_place}` : "";
    lines.push(`🕐 Ritrovo: ${c.meeting_time}${place}`);
  }
  if (c.location) lines.push(`📍 Campo: ${c.location}`);
  const fieldAddress = field?.address || null;
  if (fieldAddress) {
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fieldAddress)}`;
    lines.push(`🗺️ Indirizzo: ${fieldAddress}`);
    lines.push(`   ${mapsUrl}`);
  }
  lines.push("");

  const calledPlayers = (c.player_ids || [])
    .map((pid) => players.find((p) => p.id === pid))
    .filter(Boolean)
    .sort((a, b) => (a.jersey_number || 99) - (b.jersey_number || 99));

  lines.push(`*Convocati (${calledPlayers.length}):*`);
  calledPlayers.forEach((p, i) => {
    const num = p.jersey_number != null ? `${p.jersey_number}. ` : `${i + 1}. `;
    lines.push(`${num}${p.last_name} ${p.first_name}`);
  });

  if (c.notes) {
    lines.push("");
    lines.push(`📝 _${c.notes}_`);
  }

  lines.push("");
  lines.push("Forza ragazzi! 💪");
  return lines.join("\n");
}

export function buildParentEmails(convocation, players) {
  return (convocation.player_ids || [])
    .map((pid) => players.find((p) => p.id === pid))
    .filter(Boolean)
    .map((p) => p.parent_email)
    .filter((e) => e && e.includes("@"));
}
